import { all, put, select, takeLatest } from 'redux-saga/effects';
import { ClientComplaintsActionTypes } from './complaints-actions';
import { clientComplaintsStore } from './complaints-store';
import { AlertActionType } from '@store/alert/alert-action';
import getComplaintsListApi from '@api/clients/complaints/get-complaints-list';
import getComplaintsTypesApi from '@api/clients/complaints/get-complaints-types';
import storeComplaintsApi from '@api/clients/complaints/store-complaints';
import uploadComplaintsFileApi from '@api/clients/complaints/upload-complaints';

function* getClientComplaintsWatcher() {
  const { complaintsList, currentPage } = yield select(clientComplaintsStore);

  try {
    const complaintsListResponse: { data: { data: Array<object>, last_page: number } } = yield getComplaintsListApi({ page: currentPage, limit: 15, cache: 'no-cache' });
    yield put({
      type: ClientComplaintsActionTypes.SET_CLIENT_COMPLAINTS_LIST,
      data: {
        complaintsList: [...complaintsList, ...complaintsListResponse?.data?.data],
        lastPage: complaintsListResponse?.data?.last_page,
      },
    });
  } catch (error: any) {
    yield put({
      type: ClientComplaintsActionTypes.SET_CLIENT_COMPLAINTS_LIST,
      data: {
        complaintsList: complaintsList,
      },
    });
    yield put({
      type: AlertActionType.SHOW_ALERT,
      text: error?.message || 'در گرفتن اطلاعات شما مشکلی پیش آمده است، لطفا بعدا مراجعه نمایید',
      severity: 'danger',
    });
  }
}

function* getClientComplaintsTypesWatcher() {
  try {
    const complaintsTypesResponse: { data: Array<object>} = yield getComplaintsTypesApi({ cache: 'no-cache' });
    yield put({
      type: ClientComplaintsActionTypes.SET_COMPLAINTS_TYPES,
      data: {
        complaintsTypes: complaintsTypesResponse?.data,
      },
    });
  } catch (error: any) {
    yield put({
      type: ClientComplaintsActionTypes.SET_COMPLAINTS_TYPES,
      data: {
        complaintsTypes: [],
      },
    });
    yield put({
      type: AlertActionType.SHOW_ALERT,
      text: error?.message || 'در گرفتن اطلاعات شما مشکلی پیش آمده است، لطفا بعدا مراجعه نمایید',
      severity: 'danger',
    });
  }
}

function* storeClientComplaintsWatcher() {
  const { complaintsRequest, file } = yield select(clientComplaintsStore);

  try {
    let fileResponse: { data: any } | null = null;
    if (file) {
      fileResponse = yield uploadComplaintsFileApi({ file: file, cache: 'no-cache' });
    }
    const complaintsStoreResponse: { data: boolean} = yield storeComplaintsApi({
      requestData: fileResponse ? {
        ...complaintsRequest,
        image: {
          '1': fileResponse,
        },
      } : complaintsRequest,
      cache: 'no-cache',
    });
    if (complaintsStoreResponse?.data) {
      yield put({
        type: AlertActionType.SHOW_ALERT,
        text: 'شکایت شما با موفقیت ثبت شد.',
        severity: 'success',
      });
      yield put({
        type: ClientComplaintsActionTypes.SET_COMPLAINT_SUBMITTED,
        data: {
          complaintSubmitted: true,
        },
      });
    }
    yield put({ type: ClientComplaintsActionTypes.TOGGLE_COMPLAINTS_MODAL });
  } catch (error: any) {
    yield put({
      type: AlertActionType.SHOW_ALERT,
      text: error?.message || 'در ثبت شکایت شما مشکلی پیش آمده. لطفا مجددا تلاش کنید',
      severity: 'danger',
    });
  }
  yield put({
    type: ClientComplaintsActionTypes.SET_STORE_LOADING,
    data: {
      loading: false,
    },
  });
}

function* complaintsDataValidationWatcher() {
  const { complaintsRequestError } = yield select(clientComplaintsStore);
  if (complaintsRequestError) {
    yield put({
      type: AlertActionType.SHOW_ALERT,
      text: 'لطفا فیلد های مشخص شده را تکمیل کنید.',
      severity: 'danger',
    });
  } else {
    yield put({ type: ClientComplaintsActionTypes.STORE_COMPLAINTS_REQUEST });
  }
}

function* clientComplaintsMiddleware() {
  yield all([
    takeLatest(ClientComplaintsActionTypes.GET_CLIENT_COMPLAINTS_LIST, getClientComplaintsWatcher),
    takeLatest(ClientComplaintsActionTypes.GET_CLIENT_EXTENDED_COMPLAINTS_LIST, getClientComplaintsWatcher),
    takeLatest(ClientComplaintsActionTypes.GET_COMPLAINTS_TYPES, getClientComplaintsTypesWatcher),
    takeLatest(ClientComplaintsActionTypes.STORE_COMPLAINTS_REQUEST, storeClientComplaintsWatcher),
    takeLatest(ClientComplaintsActionTypes.SET_DATA_VALIDATION, complaintsDataValidationWatcher),
  ]);
}

export default clientComplaintsMiddleware;
